import { render, staticRenderFns } from "./ThemeServiceReg.vue?vue&type=template&id=4e5036cb&scoped=true"
import script from "./ThemeServiceReg.vue?vue&type=script&lang=js"
export * from "./ThemeServiceReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5036cb",
  null
  
)

export default component.exports